import { Spacer } from "../../../../../../components/spacer/Spacer"
import { theme } from "../../../../../../styles/stitches.config"
import Text from "../../../../../../components/Text"
import { Flex } from "../../../../../../components/flex/Flex"
import Checkbox from "../../../../../../components/checkbox/Checkbox"
import InfoBox from "../../../../../../components/info/InfoBox"
import { WEB_LINKS } from "../../../../../../constants/links"
import { Goodwe, Infigy, SolaxActive, VictronActive } from "../../../../../../images/xd/icons"
import {
  DataTariffCard,
  DesktopOnlyBr,
  DesktopOnlySpacer,
  ProductLabel,
  TextHighlight,
  Tooltip,
} from "./ProductDetailsBottom.styled"
import { Div } from "../../../../../../components/div/Div"
import { PropsWithChildren } from "react"

function LogoWithAsterisk(props: PropsWithChildren) {
  return (
    <Flex>
      {props.children}
      <Text type="textsSmall" css={{ position: "relative", top: -4 }}>
        *
      </Text>
    </Flex>
  )
}

type Props = {
  selectedProduct: string
  productionDataTariff?: boolean
  handleProductionDataTariffChange: (selected: boolean) => void
}

export function ProductDetailsBottom(props: Props) {
  const { selectedProduct, productionDataTariff, handleProductionDataTariffChange } = props
  if (!selectedProduct) {
    return null
  }

  return (
    <>
      {!selectedProduct && (
        <ProductLabel>
          <DesktopOnlySpacer />
          <Text
            type="textsLarge"
            css={{ textAlign: "center", lineHeight: theme.sizes.s6, maxWidth: "223px", display: "block" }}
          >
            Vyberte si typ smlouvy a zjistěte vaši cenu
          </Text>
        </ProductLabel>
      )}
      {selectedProduct === "consumption" && (
        <ProductLabel>
          <DesktopOnlySpacer />
          <Text type="textsSmall" css={{ lineHeight: "21px", paddingLeft: 30, display: "block" }}>
            Cena elektřiny se odvíjí od aktuální ceny na spotovém trhu. Tu můžete sledovat v
            <a
              href={WEB_LINKS.dailyPrices}
              target="_blank"
              style={{ color: theme.colors.secondary.value, textDecoration: "underline" }}
              rel="noreferrer"
            >
              &nbsp;našem přehledu
            </a>
            .
          </Text>
        </ProductLabel>
      )}
      {selectedProduct !== "consumption" && selectedProduct && (
        <Div
          css={{
            flex: "initial",
            "@md": {
              flex: 1,
            },
          }}
        >
          <DataTariffCard selected={!!productionDataTariff}>
            <Text type="headerH3" css={{ marginLeft: 36, display: "block" }}>
              <TextHighlight>Ještě výhodnější</TextHighlight>&nbsp;cena za prodej?
            </Text>
            <Spacer size={theme.space.s3_5} />
            <Checkbox
              align="start"
              checked={!!productionDataTariff}
              onChange={handleProductionDataTariffChange}
              labelCSS={{ display: "flex", cursor: "pointer" }}
              label={
                <Text type="textsSmall" css={{ lineHeight: "21px" }}>
                  Vlastním níže uvedený střídač nebo používám uvedenou automatizaci, chci levnější tarif&nbsp;
                  <DesktopOnlyBr />
                  <TextHighlight noBreak>SPOT - 450</TextHighlight> a souhlasím s poskytnutím dat ze&nbsp;
                  <DesktopOnlyBr />
                  své FVE.
                  <InfoBox
                    variant="default"
                    side="top"
                    size="small"
                    align="end"
                    inline={true}
                    css={{ position: "relative", top: -3 }}
                    contentCSS={{
                      paddingLeft: theme.space.s6,
                      paddingRight: theme.space.s6,
                      paddingTop: theme.space.s7,
                      paddingBottom: theme.space.s7,
                    }}
                  >
                    <Tooltip>
                      <Text type="textsSmall">
                        Získejte výhodnější cenu za prodej přetoků. Stačí mít střídač nebo automatizaci uvedených značek
                        a sdílet s námi data ze své FVE. Za prodej přetoků dostanete cenu na spotu a za převzetí
                        zodpovědnosti za odchylku si vezmeme jen{" "}
                        <TextHighlight color="primary">450 Kč/MWh.</TextHighlight> Sdílení dat si jednoduše napojíte
                        online, <TextHighlight color="primary">střídače Solax a GoodWe</TextHighlight> však navíc
                        vyžadují naše zařízení Delta Link.
                      </Text>
                    </Tooltip>
                  </InfoBox>
                </Text>
              }
              size={28}
              checkboxCSS={{ display: "flex", flexShrink: 0 }}
            />
            <Spacer size={theme.space.s9} />
            <Flex wrap="wrap" justify="center" align="center" css={{ gap: theme.space.s3 }}>
              <VictronActive width={110} height={32} />
              <LogoWithAsterisk>
                <SolaxActive width={74} height={28} />
              </LogoWithAsterisk>
              <LogoWithAsterisk>
                <Goodwe width={92} height={27} />
              </LogoWithAsterisk>
              <Infigy width={70} height={23} />
            </Flex>
          </DataTariffCard>
          <Spacer size={theme.space.s2_5} />
          <Text type="textsSmall" css={{ display: "flex", justifyContent: "flex-end" }}>
            * Pro tuto funkci je potřeba koupit Delta Link
          </Text>
        </Div>
      )}
    </>
  )
}
